export default __webpack_public_path__ + "static/media/delv_blue_bold1.6be65ee3.svg";